@if (componentData.data$ | async; as component) {
  <div class="contact-details" [ngClass]="isContactPage ? 'contact-page' : ''">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="contact-details-inner">
            <h4 class="contact-details__title">{{ component.title }}</h4>
            <p>{{ component.subtitle1 }}</p>
            <ul
              class="contact-details__list list-unstyled"
              [ngClass]="{ 'mb-3': !component.showDivider }"
            >
              @if (component.phoneNumber) {
                <li class="contact-details__list-item">
                  <boels-generic-link
                    [isExternal]="true"
                    [url]="'tel:' + component.phoneNumber | phoneFilter"
                    [attr.data-dm]="
                      {
                        data_type: 'cta',
                        item_name: 'contact-details phone',
                      } | json
                    "
                  >
                    <fa-icon [icon]="faPhone"></fa-icon>
                    {{ component.phoneNumber }} {{ component.phoneRate }}
                  </boels-generic-link>
                </li>
              }
              @if (component.facebookLink) {
                <li class="contact-details__list-item">
                  <boels-generic-link
                    [url]="component.facebookLink"
                    [target]="'_blank'"
                    [isExternal]="true"
                    [attr.data-dm]="
                      {
                        data_type: 'cta',
                        item_name: 'contact-details Facebook',
                      } | json
                    "
                  >
                    <fa-icon [icon]="faFacebook"></fa-icon>
                    {{ 'contact.facebookLabel' | transloco }}
                  </boels-generic-link>
                </li>
              }
              @if (component.twitterLink) {
                <li class="contact-details__list-item">
                  <boels-generic-link
                    [url]="component.twitterLink"
                    [target]="'_blank'"
                    [isExternal]="true"
                    [attr.data-dm]="
                      {
                        data_type: 'cta',
                        item_name: 'contact-details Twitter',
                      } | json
                    "
                  >
                    <fa-icon [icon]="faTwitter"></fa-icon>
                    {{ 'contact.twitterLabel' | transloco }}
                  </boels-generic-link>
                </li>
              }
              @if (component.emailAddress) {
                <li class="contact-details__list-item">
                  <boels-generic-link
                    [isExternal]="true"
                    [url]="'mailto:' + component.emailAddress"
                    [attr.data-dm]="
                      {
                        data_type: 'cta',
                        item_name: 'contact-details e-mail',
                      } | json
                    "
                  >
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                    {{ 'contact.emailLabel' | transloco }}
                  </boels-generic-link>
                </li>
              }
            </ul>
            @if (component.showDivider) {
              <hr />
            }
            <p class="text-subtle-gray_1000">{{ component.tinyText }}</p>
            <p>{{ component.subtitle2 }}</p>
            @if (component.button?.url) {
              <a
                boelsAnchorButton
                boelsGenericLink
                class="contact-details__one-call-link"
                tabindex="0"
                [variant]="'primary-brand'"
                [url]="component.button?.url"
                [target]="component.button?.target | urlTarget"
                [attr.data-dm]="
                  {
                    data_type: 'cta',
                    item_name: 'contact-details OneCall',
                  } | json
                "
              >
                {{ component.button?.linkName }}
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
